import React from 'react';
import PropTypes from 'prop-types'
import PageContent from '../../page-content/jsx/page-content.jsx';
import OptionsType from '../../options-type/jsx/options-type.jsx';
import Explanation from '../../explanation/jsx/explanation.jsx';
import NavigationControls from '../../navigation-controls/jsx/navigation-controls.jsx';
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import LoadingOverlay from '../../loading-overlay/jsx/loading-overlay.jsx';
import { useEffect } from 'react';

const Question = props => {

  const { matrixData, currentId, addToPageLog, addingToPageLog } = useStore(state =>({
    matrixData: state.matrixData,
    currentId: state.currentId,
    addToPageLog: state.addToPageLog,
    addingToPageLog: state.addingToPageLog,
  }), shallow);

  const thisPageId = currentId;

  const pageDetails = matrixData['pages'][thisPageId];
  const { page_name } = pageDetails;
  // "reference" is also available from pageDetails.  eg 1.0 (P1 & P3).

  useEffect(() => {
    if(addingToPageLog){
      addToPageLog(thisPageId);
    }
  })

  return (
    <div className="decision_wrapper bg_cerulean">
            <h2 className="decision_step">{page_name}</h2>
            <p className="decision_reference">Reference number: {props.pageId}</p>
            <div className="decision_body decision_box">
                <LoadingOverlay />
                <PageContent pageId={thisPageId} />
                <OptionsType pageId={thisPageId} />
                <Explanation pageId={thisPageId} />
                
                <NavigationControls pageId={thisPageId} pageName={page_name} />

            </div>
        </div>
  )
}

Question.propTypes = {
  pageId: PropTypes.string
}

export default Question;